import { CsvHeader } from 'types'

export const BULK_SITE_PREFERENCES_PUBLISH_FLOW = {
  publishFlowStructureId: 2,
  publishFlowName: '2026-2027',
}

export const csvTemplateHeaders: CsvHeader[] = [
  { label: 'SiteId', key: 'siteId' },
  { label: 'Regions', key: 'Regions' },
  { label: 'bpu_enabled', key: 'bpu_enabled' },
  { label: 'cpu_enabled', key: 'cpu_enabled' },
  { label: 'k5p_enabled', key: 'k5p_enabled' },
  { label: 'msp_enabled', key: 'msp_enabled' },
  {
    label: 'hsp_enabled',
    key: 'hsp_enabled',
  },
  { label: 'dwbp_enabled', key: 'dwbp_enabled' },
  { label: 'ti_assessments_enabled', key: 'ti_assessments_enabled' },
]
